import { useCommunitySwitcherContext } from "@circleco/community-switcher/context/CommunitySwitcherContext";
import { cn } from "@circleco/community-switcher/helpers/cn";
import { Tooltip } from "@circleco/compass/components/Tooltip";

export const CommunitySwitcherDiscoverButton = () => {
  const { featureFlags, t } = useCommunitySwitcherContext();
  const to = featureFlags?.discoverLinkTo;
  if (!to || !featureFlags?.showDiscoverButton) {
    return null;
  }
  const isActive = Boolean(featureFlags.isDiscoverRouteActive);
  const onDiscoverClick = featureFlags.onDiscoverClick;
  return (
    <Tooltip
      content={t("discover.tooltip")}
      delay={200}
      side="right"
      sideOffset={12}
    >
      <a
        className={cn(
          "size-9 hover:bg-secondary-hover focus:bg-secondary-hover !m-0 flex items-center justify-center rounded-lg border border-transparent transition-colors duration-150",
          {
            "active border-primary switcher__active_community": isActive,
          },
        )}
        data-testid="community-switcher-link"
        href={to}
        onClick={
          onDiscoverClick
            ? e => {
                e.preventDefault();
                onDiscoverClick(e);
              }
            : undefined
        }
      >
        <div
          className="brand-icon brand-icon__initial size-[30px] flex !items-center !justify-center !rounded-md !outline-none"
          style={{
            color: "#FFF",
          }}
        >
          <img
            src="https://assets-v2.circle.so/11oepcqxo8q008li605zp2ol7a8a"
            alt={t("discover.logo_alt")}
            width={30}
            height={30}
          />
        </div>
      </a>
    </Tooltip>
  );
};
